import { isItemBlankSampleOrPrintedSample } from 'swag-common/utils/items/is-item-sample.service';
import { getItemPriceMultiplier } from 'swag-common/business-logic/get-item-price-multiplier.logic';
import { Price } from 'swag-common/utils/price';
import { DesignUploadMode } from '../../interfaces';
import calculateSetupFeeValue from '../calculate-setup-fee-value.logic';
import { getDataForGettingItemShippingCost, getItemShippingCost } from './get-item-shipping-cost.service';
function getSetupFeeToUseForPricePerItemCalculation(items) {
  return items.reduce((result, item) => {
    const multiplier = getItemPriceMultiplier(item);
    let setupFee = calculateSetupFeeValue({
      product: item.prod,
      logos: item.logos,
      texts: null,
      isSample: isItemBlankSampleOrPrintedSample(item),
      prodTime: item.prodTime,
      multiplier
    });
    if (item.setupFeeDeductionDiscount) {
      setupFee = setupFee - item.setupFeeDeductionDiscount;
    }
    const blendedQuantityFromThisBox = items.reduce((sum, innerItem) => {
      if (innerItem.asRelatedItemId === item.asRelatedItemId) {
        return sum + innerItem.quantity;
      }
      return sum;
    }, 0);
    const screenPrice = Price.getScreenPriceForRelatedProduct(setupFee, blendedQuantityFromThisBox || item.quantity);
    const setupFeeToAdd = screenPrice * item.quantity;
    const setupFeeToUseForPricePerItemCalculation = Price.getScreenPriceForRelatedProduct(setupFee, item.blendedQuantity || item.quantity) * item.quantity;
    return {
      totalBoxSetupFee: result.totalBoxSetupFee + setupFeeToAdd,
      setupFeeToUseForPricePerItemCalculation: result.setupFeeToUseForPricePerItemCalculation + setupFeeToUseForPricePerItemCalculation
    };
  }, {
    totalBoxSetupFee: 0,
    setupFeeToUseForPricePerItemCalculation: 0
  });
}
export const getBoxItemsPricing = (items, {
  totalWithShipping = false
} = {}) => {
  const box = items.find(i => {
    var _i$prod;
    return ((_i$prod = i.prod) === null || _i$prod === void 0 ? void 0 : _i$prod.designUploadMode) === DesignUploadMode.box;
  });
  if (!box) {
    return {
      total: 0,
      itemPrice: 0,
      totalBoxSetupFee: 0
    };
  }
  const {
    quantity
  } = box;
  const shippingPrice = getItemShippingCost(getDataForGettingItemShippingCost(box, items));
  const totalItemsPrice = items.reduce((all, next) => all + next.price, 0);
  let total = totalItemsPrice;
  if (totalWithShipping) {
    total += shippingPrice;
  }
  const {
    totalBoxSetupFee,
    setupFeeToUseForPricePerItemCalculation
  } = getSetupFeeToUseForPricePerItemCalculation(items);
  const itemPrice = (totalItemsPrice - setupFeeToUseForPricePerItemCalculation) / quantity;
  return {
    total,
    itemPrice,
    totalBoxSetupFee
  };
};